import ManagedTable, { ManagedColumn, ManagedTableProps } from '../../../../common/table/ManagedTable';
import { CheckCircleFilled } from '@ant-design/icons';
import useWindowDimensions from '../../../../common/hooks/useWindowDimensions';
import React from 'react';
import { RadRestriction } from '../../../../model/SOL49';

export interface QualifiedRadRestriction {
    restriction: RadRestriction;
    type?: 'OFFLOAD' | 'ONLOAD' | 'ONLOAD_OFFLOAD';
}
export class RadRestrictionsColumn {
    public static readonly RAD_RESTRICTION_SELECTED_COLUMN = new ManagedColumn<QualifiedRadRestriction>(
        '',
        '2em',
        () => (
            <div className={'check-circle'} style={{ textAlign: 'center' }}>
                <CheckCircleFilled />
            </div>
        ),
        { name: 'selected' },
    );
    public static readonly RAD_RESTRICTION_ID = new ManagedColumn<QualifiedRadRestriction>(
        'Id',
        '8em',
        obj => obj.restriction.id,
    );
    public static readonly RAD_RESTRICTION_STATUS = new ManagedColumn<QualifiedRadRestriction>('Status', '8em', obj =>
        obj.restriction.preAgreed ? 'Pre-agreed' : 'Draft',
    );
    public static readonly RAD_RESTRICTION_TYPE = new ManagedColumn<QualifiedRadRestriction>(
        'Type',
        '8em',
        obj => obj.type,
    );
}

const RadRestrictionTable = (props: ManagedTableProps<QualifiedRadRestriction>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <ManagedTable<QualifiedRadRestriction> fontSize={fontSize} {...props} />;
};

export default RadRestrictionTable;
